module.exports = __webpack_public_path__ + "img/login_icon.ba7895b5.svg";